<template>
    <div class="v-setting-binary">
        <div class="v-setting-binary__label">
            {{ label }}
        </div>

        <div class="v-setting-binary__switch">
            <v-light-switch :disabled="disabled" v-model="val" @input="emit"></v-light-switch>
        </div>

    </div>

</template>

<script>

    import vLightSwitch from "./vLightswitch"

    export default {
        name: "BinarySetting",
        components: {
            vLightSwitch
        },
        data() {
            return {
                val: this.value
            }
        },
        props: {
            value: {type: [Boolean, Number], default: false},
            disabled: {type: Boolean, default: false},
            label: {type: String, default: ""}
        },
        methods: {
            emit($event) {
                console.log($event);
                this.$emit('input', $event)
            }
        },
        watch: {
            value() {
                this.val = this.value;
            }
        }

    }
</script>

<style lang="scss">
    .v-setting-binary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .95em 0;

        &__label {
            font-weight: 600;
            font-size: .85em;
        }
    }


</style>